<script setup>
import { ref, watch, computed, onMounted, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router";
import _ from "lodash";
import moment from "moment";
import { usePageLoadingStore } from "../../../../../stores/pageLoading";
import jobFairUserService from "../../../../user/services/jobFair/jobFairUserService";
import adminJobfairService from "../../../services/jobfair/adminJobfairService";
import adminJoinStateService from "../../../services/jobfair/adminJoinStateService";
import SNBAdmin from "../../../../../layouts/nav/SNBAdmin.vue";
import KSASecondaryButton from "../../../../../components/ui-components/button/KSASecondaryButton.vue";
import KSAPrimaryButton from "../../../../../components/ui-components/button/KSAPrimaryButton.vue";
import JobFairJobNoticeModal from "../../../../user/components/modal/jobFair/JobFairJobNoticeModal.vue";
import RecruitmentHallCorpModal from "@/pages/admin/components/modal/jobFair/RecruitmentHallCorpModal.vue";
import RecruitmentHallModal from "@/pages/admin/components/modal/jobFair/RecruitmentHallModal.vue";
import JobFairResumeModal from "@/pages/user/components/modal/jobFair/JobFairResumeModal.vue";
import { useAlertStore } from "../../../../../stores/alertStore";
const { $alert, $confirm } = useAlertStore();

const route = useRoute();
const router = useRouter();
const loadingStore = usePageLoadingStore();
const { $pageListBoardNo, $toast, $number, $gbNameKR, $yyyymmddHHmmss, $adminJoinStateGb } = getCurrentInstance().appContext.config.globalProperties;

const ojfId = ref(0);
const adminJoinStateGb = ref($adminJoinStateGb);  // 행사 참가 상태
const ojfGb = ref(route.query.ojfGb || '');

onMounted(() => {
    const { id } = route.params;
    if (!id) {
        goBack();
    } else {
        ojfId.value = id;
        retrieveOnlineJobFair();                  // 행사 정보 조회(for 행사명)
        retrieveRecruitmentHallCountByOjfId();    // 재직자/기업 참가 상태별 개수 조회
        retrieveAllRecruitmentHallStatusPaging(); // 재직자/기업 리스트 조회
    }
});

const ojfDetail = ref({});          // 행사 정보(for 행사명)
// 01 신청 접수 완료 02 신청 검토중 03 신청 취소(사용자) 04 신청 취소(Admin) 11 승인(참가확정) 21 반려(참가불가)
const corpJoinStateCnt = ref([]);   // 재직자/기업 참가 상태별 개수
const corpJoinStateList = ref([]);  // 재직자/기업 리스트
const stuJoinStateCnt = ref([]);    // 학생/취업준비생 참가 상태별 개수
const stuJoinStateList = ref([]);   // 학생/취업준비생 리스트

const searchInput = ref({
    joinStateGbsList: ['01', '02', '03', '04', '11', '21'],
    searchType: 'corpName', // 재직자/기업 TAB(corpName 기업명, userName 이름, id 아이디, code 회원코드), 학생/취업준비생 TAB(userName 이름, id 아이디, code 회원코드)
    searchInput: '',
    searchDurationType: 'all',
    startYmd: '',
    endYmd: '',
});

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(0);
const totalCount = ref(0);
const searchOpen = ref(true);

const tabIndex = ref(1);
const tabIndex2 = ref(1);

const recruitmentHallCorpModal = ref(null); // 신청정보 - 기업
const recruitmentHallModal = ref(null); // 신청정보 - 구직자
const jobNoticeModal = ref(null); // 채용공고
const jobFairResumeModal = ref(null); // 이력서

// 초기화 버튼 처리를 위한 ref 지정
const adminJoinStateGbsListRef = ref(null);
const searchTypeRef = ref(null);
const datepickerTermsRef1 = ref(null);
const datepickerTermsRef2 = ref(null);

// 체크 박스 처리
const isSelectedAll = ref(false);
let disabledWatchIsSelectedAll = false; // 개별 checkbox 클릭시 watch disabled
let disabledWatchList = false; // all checkbox 클릭시 watch disabled

// 재직자/기업. 상단 체크박스 클릭(전체 체크 or 전체 해제)
watch(isSelectedAll, (newValue)=>{
    if(!disabledWatchIsSelectedAll) {
        let newList = [];
        if( tabIndex.value === 1 ) { // 재직자/기업
            newList = _.cloneDeep(corpJoinStateList.value);
        } else if( tabIndex.value === 2 ) { // 학생/취업준비생
            newList = _.cloneDeep(stuJoinStateList.value);
        }
        _.each(newList, (el)=>{
            el.checked = newValue;
        });
        disabledWatchList = true;
        if( tabIndex.value === 1 ) { // 재직자/기업
            corpJoinStateList.value = newList;
        } else if( tabIndex.value === 2) { // 학생/취업준비생
            stuJoinStateList.value = newList;
        }
    } else {
        disabledWatchIsSelectedAll = false;
    }
})
// 재직자/기업. 리스트 개별 체크박스 클릭
watch(corpJoinStateList, (newValue)=>{
    if(!disabledWatchList) {
        const checkedList = _.filter(newValue, { checked: true});
        if(checkedList.length === newValue.length) {
            disabledWatchIsSelectedAll = true;
            isSelectedAll.value = true;
        } else {
            if(isSelectedAll.value) {
                disabledWatchIsSelectedAll = true;
                isSelectedAll.value = false;
            }
        }
    } else {
        disabledWatchList = false;
    }
}, { deep: true})

// 학생/취업준비생. 리스트 개별 체크박스 클릭
watch(stuJoinStateList, (newValue)=>{
  if(!disabledWatchList) {
    const checkedList = _.filter(newValue, { checked: true});
    if(checkedList.length === newValue.length) {
      disabledWatchIsSelectedAll = true;
      isSelectedAll.value = true;
    } else {
      if(isSelectedAll.value) {
        disabledWatchIsSelectedAll = true;
        isSelectedAll.value = false;
      }
    }
  } else {
    disabledWatchList = false;
  }
}, { deep: true})

// 검색조건 - 날짜검색기준 (all 모든 기간, term 기간 검색)
const searchDurationTypeGroup = ref([
    { label:'모든 기간', value: 'all' },
    { label:'기간 검색', value: 'term' },
])

// 검색조건 - 페이지 크기
const pageSizeGroup = ref([
    { label:'10개씩 보기', value: '10' },
    { label:'30개씩 보기', value: '30' },
    { label:'50개씩 보기', value: '50' },
    { label:'100개씩 보기', value: '100' },
])

// 행사 참가 상태
const adminJoinStateGBList = [
    { label: '신청 접수 완료', value: '01'},
    { label: '신청 검토중', value: '02'},
    { label: '신청 취소(Admin)', value: '04'},
    { label: '승인(참가확정)', value: '11'},
    { label: '반려(참가불가)', value: '21'},
]

// tabIndex
const tabOptions = ref([
    {label: '재직자/기업', value: 1},
    {label: '학생/취업준비생', value: 2},
])

// 재직자/기업
const searchTypeGroupCorp = ref([
    { label:"기업명", value: "corpName", placeholder: "기업명을 입력해주세요."  },
    { label:"이름", value: "userName", placeholder: "이름을 입력해주세요." },
    { label:'아이디', value: 'id', placeholder: "아이디를 입력해주세요." },
    { label:"회원코드", value: "code", placeholder: "회원코드를 입력해주세요."  },
]);
const searchInputPlaceholderCorp = computed(()=>{
    const option = _.find(searchTypeGroupCorp.value, { value: searchInput.value.searchType });
    if(option) {
        return option.placeholder;
    } else {
        return '';
    }
})

// 학생/취업준비생
const searchTypeGroupStu = ref([
    { label:"이름", value: "userName", placeholder: "이름을 입력해주세요." },
    { label:'아이디', value: 'id', placeholder: "아이디를 입력해주세요." },
    { label:"회원코드", value: "code", placeholder: "회원코드를 입력해주세요."  },
]);
const searchInputPlaceholderStu = computed(()=>{
    const option = _.find(searchTypeGroupStu.value, { value: searchInput.value.searchType });
    if(option) {
        return option.placeholder;
    } else {
        return '';
    }
})

// 행사 정보 조회
const retrieveOnlineJobFair = () => {
    loadingStore.loading = true;
    adminJobfairService.retrieveOnlineJobFair(ojfId.value)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                ojfDetail.value = res.data.result;
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};


// 신청정보 보기 - 재직자/기업
const onClickRecruitmentHallCorp = async (corpId) => {
    if(corpId) {
        await recruitmentHallCorpModal.value.recruitmentHallCorpDetail(ojfId.value, corpId);
        await recruitmentHallCorpModal.value.show();
    }
}

// 신청정보 보기 - 구직자
const onClickRecruitmentHall = async (userId) => {
    if(userId) {
        await recruitmentHallModal.value.recruitmentHallDetail(ojfId.value, userId);
        await recruitmentHallModal.value.show();
    }
}

// 재직자/기업 START
// 1. 재직자/기업 - tab 상태별 개수
const retrieveRecruitmentHallCountByOjfId = () => {
    loadingStore.loading = true;
    adminJobfairService.retrieveRecruitmentHallCountByOjfId(ojfId.value)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                corpJoinStateCnt.value = res.data.result;
            }
        }).catch((res) => {
            loadingStore.loading = false;
            $toast("error", res);
    });
};

// 2. 재직자/기업 - 참가신청 리스트
const retrieveAllRecruitmentHallStatusPaging = () => {
    const now = new Date();
    const startYmd = searchInput.value.startYmd ? searchInput.value.startYmd : moment(now).format('YYYYMMDD');
    const endYmd = searchInput.value.endYmd ? searchInput.value.endYmd : moment().add(1, 'month').format('YYYYMMDD');

    let paramObj = {
        ojfId: ojfId.value,
        searchJoinStateGb: _.map(searchInput.value.joinStateGbsList).join(','),
        searchType: searchInput.value.searchType,
        searchInput: searchInput.value.searchInput,
        startYmd: searchInput.value.searchDurationType === 'all' ? '' : startYmd,
        endYmd: searchInput.value.searchDurationType === 'all' ? '' : endYmd,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminJoinStateService.retrieveAllRecruitmentHallStatusPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
              const result = res.data.result;
              totalPages.value = result.totalPages;
              totalCount.value = result.totalElements;
              corpJoinStateList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
            loadingStore.loading = false;
            $toast("error", res);
    });
};

// 3. 재직자/기업 - '엑셀 다운로드' 클릭
const onClickCorpExcelDownload = async () => {
    const ok = await $confirm(["재직자/기업 참가신청 목록을 내 PC로 다운로드할까요?"], "다운로드");
    if(ok){
        retrieveAllRecruitmentHallStatusExcel();
    }
}

// 3-1. 재직자/기업 - 엑셀 다운로드
const retrieveAllRecruitmentHallStatusExcel = () => {
    let paramObj = {
        ojfId: ojfId.value,
        searchJoinStateGb: _.map(searchInput.value.joinStateGbsList).join(','),
        searchType: searchInput.value.searchType,
        searchInput: searchInput.value.searchInput,
        startYmd: searchInput.value.searchDurationType === 'all' ? '' : searchInput.value.startYmd,
        endYmd: searchInput.value.searchDurationType === 'all' ? '' : searchInput.value.endYmd,
    }
    $toast('', `다운로드 데이터 생성을 시작합니다.`);
    loadingStore.loading = true;
    adminJoinStateService.retrieveAllRecruitmentHallStatusExcel(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            try {
                const href = URL.createObjectURL(res.data);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `${ ojfDetail.value.ojfName }_${moment().format("YYYYMMDD")}_재직자/기업 참가신청 리스트.xlsx`); //or any other extension
                document.body.appendChild(link);
                link.click();
                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            } catch(e) {
                console.error('다운로드 파일 처리 중 오류가 발생했습니다:', e);
            }
        }).catch((err) => {
            loadingStore.loading = false;
            let errorMessage = '다운로드 데이터 생성 중 오류가 발생했습니다.';
            // Blob 응답 처리
            err.response.data.text()  // Blob을 텍스트로 변환
                .then(text => {
                    try {
                        // 텍스트를 JSON으로 파싱
                        const responseData = JSON.parse(text);
                        // 메시지 추출
                        if (responseData?.result?.message) {
                            errorMessage = responseData.result.message;
                        }
                    } catch (parseError) {
                        console.error('에러 메시지 파싱 중 오류가 발생했습니다.:', parseError);
                    }
                    // Toast에 에러 메시지 표시
                    $toast('error', errorMessage);
                });
        });
};

// 4. 재직자/기업 tab - 참가 상태 변경
const onClickCorpJoinState = async (index) => {
    const checkedUsers = _.filter(corpJoinStateList.value, (user)=>{
        return user.checked;
    });
    if(checkedUsers.length === 0) {
        $alert("참가 상태를 변경할 신청을 선택하세요.");
        return false;
    }
    const ok = await $confirm(["참가 상태를 변경할까요?"], "변경");
    if(ok){
        // 참가 상태 변경할 함수
        updateCorpJoinState(checkedUsers, index);
    }
}

// 4-1. 참가 상태 변경 (재직자/기업)
const updateCorpJoinState = (checkedUsers, index) => {
    let paramObj = {
        ojfId: ojfId.value,
        joinStateGb: adminJoinStateGBList[index].value,
        recruitmentHallSeqList: _.map(checkedUsers, (user)=> user.recruitmentHallSeq),
    }
    loadingStore.loading = true;
    adminJoinStateService.updateCorpJoinState(paramObj)
        .then( (res) => {
            loadingStore.loading = false;
            // console.log(res);
            if(res.data.code.toLowerCase() === 'success') {
                const result = res.data.result;
                const msg = '참가 상태를 변경했습니다.';
                $toast('', msg);
                retrieveRecruitmentHallCountByOjfId();
                retrieveAllRecruitmentHallStatusPaging();
            }
        }).catch( (err) =>  {
        console.log(err);
        loadingStore.loading = false;
        $toast('error');
    });
}

// 채용공고 보기
const onClickJobNotice = async (jobNoticeSeq, corpId) => {
    let mode;
    if (ojfGb.value === '01') {
      mode = 'openRecruitment'
    }
    if(jobNoticeSeq) {
        jobNoticeModal.value.init(false, false, false, ojfId.value, undefined, undefined, undefined, undefined, undefined, mode);
        await jobNoticeModal.value.ojfCropJobNoticeDetail(jobNoticeSeq);
        await jobNoticeModal.value.ojfCorpRecruitmentHall(ojfId.value, corpId);
        await jobNoticeModal.value.ojfCorporationDetail(corpId);
        await jobNoticeModal.value.show();
    }
}
// 재직자/기업 END

// 학생/취업준비생 START
// 1. 학생/취업준비생 - tab 상태별 개수
const retrieveEntryCountByOjfId = async () => {
    loadingStore.loading = true;
    await adminJobfairService.retrieveEntryCountByOjfId(ojfId.value)
        .then((res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
                stuJoinStateCnt.value = res.data.result;
            }
        }).catch((res) => {
            loadingStore.loading = false;
            $toast("error", res);
        });
};

// 2. 학생/취업준비생 - 참가신청 리스트
const retrieveAllEntryStatusPaging = () => {
    const now = new Date();
    const startYmd = searchInput.value.startYmd ? searchInput.value.startYmd : moment(now).format('YYYYMMDD');
    const endYmd = searchInput.value.endYmd ? searchInput.value.endYmd : moment().add(1, 'month').format('YYYYMMDD');

    let paramObj = {
        ojfId: ojfId.value,
        searchJoinStateGb: _.map(searchInput.value.joinStateGbsList).join(','),
        searchType: searchInput.value.searchType,
        searchInput: searchInput.value.searchInput,
        startYmd: searchInput.value.searchDurationType === 'all' ? '' : startYmd,
        endYmd: searchInput.value.searchDurationType === 'all' ? '' : endYmd,
        pageNumber: currentPage.value,
        size: pageSize.value,
    }
    loadingStore.loading = true;
    adminJoinStateService.retrieveAllEntryStatusPaging(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            if (res.data.code.toLowerCase() === "success") {
              const result = res.data.result;
              totalPages.value = result.totalPages;
              totalCount.value = result.totalElements;
              stuJoinStateList.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
            }
        }).catch((res) => {
        loadingStore.loading = false;
        $toast("error", res);
    });
};

// 3. 학생/취업준비생 - '엑셀 다운로드' 클릭
const onClickStuExcelDownload = async () => {
    const ok = await $confirm(["학생/취업준비생 참가신청 목록을 내 PC로 다운로드할까요?"], "다운로드");
    if(ok){
        retrieveAllEntryStatusExcel();
    }
}

// 3-1. 학생/취업준비생 - 엑셀 다운로드
const retrieveAllEntryStatusExcel = () => {
    let paramObj = {
        ojfId: ojfId.value,
        searchJoinStateGb: _.map(searchInput.value.joinStateGbsList).join(','),
        searchType: searchInput.value.searchType,
        searchInput: searchInput.value.searchInput,
        startYmd: searchInput.value.searchDurationType === 'all' ? '' : searchInput.value.startYmd,
        endYmd: searchInput.value.searchDurationType === 'all' ? '' : searchInput.value.endYmd,
    }
    $toast('', `다운로드 데이터 생성을 시작합니다.`);
    loadingStore.loading = true;
    adminJoinStateService.retrieveAllEntryStatusExcel(paramObj)
        .then( async (res) => {
            loadingStore.loading = false;
            try {
                const href = URL.createObjectURL(res.data);

                // create "a" HTML element with href to file & click
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', `${ ojfDetail.value.ojfName }_${moment().format("YYYYMMDD")}_학생/취업준비생 참가신청 리스트.xlsx`); //or any other extension
                document.body.appendChild(link);
                link.click();
                // clean up "a" element & remove ObjectURL
                document.body.removeChild(link);
                URL.revokeObjectURL(href);
            } catch(e) {
                console.error('다운로드 파일 처리 중 오류가 발생했습니다:', e);
            }
        }).catch((err) => {
        loadingStore.loading = false;
        let errorMessage = '다운로드 데이터 생성 중 오류가 발생했습니다.';
        // Blob 응답 처리
        err.response.data.text()  // Blob을 텍스트로 변환
            .then(text => {
                try {
                    // 텍스트를 JSON으로 파싱
                    const responseData = JSON.parse(text);
                    // 메시지 추출
                    if (responseData?.result?.message) {
                      errorMessage = responseData.result.message;
                    }
                } catch (parseError) {
                    console.error('에러 메시지 파싱 중 오류가 발생했습니다.:', parseError);
                }
                // Toast에 에러 메시지 표시
                $toast('error', errorMessage);
            });
      });
};

// 4. 학생/취업준비생 tab - 참가 상태 변경
const onClickStuJoinState = async (index) => {
    const checkedUsers = _.filter(stuJoinStateList.value, (user)=>{
        return user.checked;
    });
    if(checkedUsers.length === 0) {
        $alert("참가 상태를 변경할 신청을 선택하세요.");
        return false;
    }
    const ok = await $confirm(["참가 상태를 변경할까요?"], "변경");
    if(ok){
        // 참가 상태 변경할 함수
        updateStuJoinState(checkedUsers, index);
    }
}

// 4-1. 참가 상태 변경 (학생/취업준비생)
const updateStuJoinState = (checkedUsers, index) => {
    let paramObj = {
        ojfId: ojfId.value,
        joinStateGb: adminJoinStateGBList[index].value,
        entrySeqList: _.map(checkedUsers, (user)=> user.entrySeq),
    }
    loadingStore.loading = true;
    adminJoinStateService.updateEntryJoinState(paramObj)
        .then( (res) => {
            loadingStore.loading = false;
            // console.log(res);
            if(res.data.code.toLowerCase() === 'success') {
                const msg = '참가 상태를 변경했습니다.';
                $toast('', msg);
                retrieveEntryCountByOjfId()
                retrieveAllEntryStatusPaging();
            }
        }).catch( (err) =>  {
        console.log(err);
        loadingStore.loading = false;
        $toast('error');
    });
}

// 이력서 보기
const onClickMyResume = async (resumeId) => {
    if(resumeId) {
        jobFairResumeModal.value.init(false);
        await jobFairResumeModal.value.retrieveJobFairRecordDetail(resumeId, ojfId);
        await jobFairResumeModal.value.show();
    }
}

// 학생/취업준비생 END

// tabIndex 변경
const onChangeTab = ({ value }) => {
    tabIndex.value = value;
    tabIndex2.value = 1;

    currentPage.value = 1;
    pageSize.value = 10;
    searchOpen.value = true;

    clearSearchInput();
    retrieveList();
}

// tabIndex2 변경
const onChangeTab2 = ({ value }) => {
    tabIndex2.value = value;

    currentPage.value = 1;
    pageSize.value = 10;
    searchOpen.value = true;

    clearSearchInput();
    retrieveList();
}

// 페이지 선택
const onSelectPage = (pageNo) => {
    currentPage.value = pageNo;
    retrieveList();
};

// 페이지 사이즈 변경. 10,30,50,100
const onSelectPageSize = (option) => {
    pageSize.value = option.value;
    currentPage.value = 1;
    retrieveList();
}

// 검색 - searchType 셀렉트 박스 선택시
const onSelectSearchTypeGroup = (option) => {
    searchInput.value.searchType = option.value;
}

// 검색 - '초기화' 버튼 클릭
const clearSearchInput = () => {
    searchInput.value = {
        joinStateGbsList: ['01', '02', '03', '04', '11', '21'],
        searchType: 'corpName', // corpName 기업명, userName 이름, id 아이디, code 회원코드
        searchInput: '',
        searchDurationType: 'all',
        startYmd: '',
        endYmd: '',
    }

    // searchInput 초기화
    if(tabIndex.value === 1) { // 재직자/기업
        searchInput.value.searchType = 'corpName';
        if (datepickerTermsRef1.value && typeof datepickerTermsRef1.value.initDates === 'function') {
            datepickerTermsRef1.value.initDates();
        }
    } else if(tabIndex.value === 2) { // 학생/취업준비생
        searchInput.value.searchType = 'userName';
        if (datepickerTermsRef2.value && typeof datepickerTermsRef2.value.initDates === 'function') {
            datepickerTermsRef2.value.initDates();
        }
    }

    if(tabIndex2.value === 2) {
        searchInput.value.joinStateGbsList = ['02']
    } else if(tabIndex2.value === 3) {
        searchInput.value.joinStateGbsList = ['11']
    } else if(tabIndex2.value === 4) {
        searchInput.value.joinStateGbsList = ['21']
    } else if(tabIndex2.value === 5) {
        searchInput.value.joinStateGbsList = ['03', '04']
    }

    adminJoinStateGbsListRef.value.initOptionsWithValues(searchInput.value.joinStateGbsList);
    searchTypeRef.value.initSelectedOption(searchInput.value.searchType);
}

// 검색 - '검색' 버튼 click
const onClickSearch = () => {
    currentPage.value = 1;
    retrieveList();
}

// tab별 리스트 불러 오기 공통 함수
const retrieveList = () => {
    if(tabIndex.value === 1) { // 재직자/기업
        if(tabIndex2.value === 1) {
            //searchInput.value.joinStateGbsList = ['01', '02', '03', '04', '11', '21']
            isSelectedAll.value = false;
            disabledWatchIsSelectedAll = false;
            disabledWatchList = false;
        } else if(tabIndex2.value === 2) {
            searchInput.value.joinStateGbsList = ['02']
        } else if(tabIndex2.value === 3) {
            searchInput.value.joinStateGbsList = ['11']
        } else if(tabIndex2.value === 4) {
            searchInput.value.joinStateGbsList = ['21']
        } else if(tabIndex2.value === 5) {
            searchInput.value.joinStateGbsList = ['03', '04']
        }

        retrieveRecruitmentHallCountByOjfId();
        retrieveAllRecruitmentHallStatusPaging();

    } else if(tabIndex.value === 2) { // 학생/취업준비생
        if(tabIndex2.value === 1) {
            //searchInput.value.joinStateGbsList = ['01', '02', '03', '04', '11', '21']
            isSelectedAll.value = false;
            disabledWatchIsSelectedAll = false;
            disabledWatchList = false;
        } else if(tabIndex2.value === 2) {
            searchInput.value.joinStateGbsList = ['02']
        } else if(tabIndex2.value === 3) {
            searchInput.value.joinStateGbsList = ['11']
        } else if(tabIndex2.value === 4) {
            searchInput.value.joinStateGbsList = ['21']
        } else if(tabIndex2.value === 5) {
            searchInput.value.joinStateGbsList = ['03', '04']
        }

        retrieveEntryCountByOjfId();
        retrieveAllEntryStatusPaging();
    }
}

// 행사 목록으로 이동
const goJoinState = () => {
    router.push({ name: "JoinState" });
}

// 행사 상세로 이동
const goOjfDetail = () => {
    router.push({ name: 'OjfDetail', params:{id: ojfId.value} })
}

// 행사 상세 새 창으로 열기
const openOjfDetailInNewWindow = () => {
    const url = router.resolve({
        name: 'OjfDetail',
        params: { id: ojfId.value },
    }).href;

    const windowFeatures = 'width=1000,height=800,top=100,left=100,resizable=yes,scrollbars=yes';
    window.open(url, '_blank', windowFeatures);
}

// 뒤로
const goBack = () => {
    router.go(-1);
}
</script>

<template>
    <div class="content">
        <div class="sub-title">
            <h3>{{ ojfDetail.ojfName }}</h3>
        </div>
        <div class="list-top space-between">
            <KSASecondaryButton class="gray_button" text="목록" @click="goJoinState" />
            <div>
                <KSASecondaryButton class="gray_button ml-xs" text="행사 상세 새 창 보기" @click="openOjfDetailInNewWindow" />
            </div>
        </div>
        <KSATab style="grid-template-columns: repeat(2, 1fr);" class="mb-sm"
            :options="tabOptions"
            @change="onChangeTab"
        />

        <!-- s: tabIndex 1 : 재직자/기업 -->
        <div v-if="tabIndex === 1">
            <KSATab style="grid-template-columns: repeat(5, 1fr);" class="mb-lg"
                    :options="[
                                {label: `참가신청${'(' + corpJoinStateCnt.totalCorpJoinState + ')'}`, value: 1},
                                {label: `신청검토중${'(' + corpJoinStateCnt.corpJoinState02 + ')'}`, value: 2},
                                {label: `승인-참가확정${'(' + corpJoinStateCnt.corpJoinState11 + ')'}`, value: 3},
                                {label: `반려-참가불가${'(' + corpJoinStateCnt.corpJoinState21 + ')'}`, value: 4},
                                {label: `취소${'(' + (Number(corpJoinStateCnt.corpJoinState03) + Number(corpJoinStateCnt.corpJoinState04)) + ')'}`, value: 5},
                                ]"
                    @change="onChangeTab2"
            />
            <div>
                <!-- s: 검색 -->
                <div class="filter-wrap" :class="{'open': searchOpen}">
                    <p @click="searchOpen = !searchOpen">검색</p>
                    <div class="filter">
                        <dl v-show="tabIndex2 === 1">
                            <dt style="display:block;"><span>참가 상태</span><br /><small style="font-weight: normal;">복수 선택
                                가능</small></dt>
                            <dd>
                                <KSACheckBoxGroup
                                    ref="adminJoinStateGbsListRef"
                                    className="mr-md"
                                    name="ojfStateGbList"
                                    v-model="searchInput.joinStateGbsList"
                                    :options="adminJoinStateGb" />
                            </dd>
                        </dl>
                        <!-- 기업명, 이름, 아이디, 회원코드 검색 -->
                        <dl>
                            <dt>
                                <KSASelect ref="searchTypeRef" :options="searchTypeGroupCorp" class="select" @selectOption="onSelectSearchTypeGroup"/>
                            </dt>
                            <dd>
                                <KSAInput class="text-box" v-model="searchInput.searchInput" :placeholder="searchInputPlaceholderCorp" />
                            </dd>
                        </dl>
                        <dl>
                            <dt>참가 신청일</dt>
                            <dd class="text-box">
                                <div class="grid">
                                    <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                        <KSARadioButton class="mr-md" name="searchDurationGb" :label="group.label" v-model="searchInput.searchDurationType" :value="group.value" />
                                    </template>
                                    <div style="display: inline-block;" v-show="searchInput.searchDurationType !== 'all'">
                                        <KSADatepickerTerms
                                            ref="datepickerTermsRef1"
                                            :startDate="searchInput.startYmd"
                                            :endDate="searchInput.endYmd"
                                            @update:startDate="(value)=> searchInput.startYmd = value"
                                            @update:endDate="(value)=> searchInput.endYmd = value"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </dl>
                        <div class="btn-wrap">
                            <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                            <KSAPrimaryButton text="검색" @click="onClickSearch" />
                        </div>
                    </div>
                </div>
                <!-- e: 검색 -->
                <!-- s: 버튼영역 -->
                <div class="list-top">
                    <div class="grid">
                        <KSAPrimaryButton v-if="tabIndex2 === 1" text="엑셀 다운로드" @click="onClickCorpExcelDownload" />
                        <KSADropdownButton v-if="tabIndex2 === 1 || tabIndex2 === 2" class="gray_button ml-xs" text="심사 상태 변경" :options="adminJoinStateGBList" @click="onClickCorpJoinState" />
                    </div>
                    <div>
                        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                    </div>
                </div>
                <!-- e: 버튼영역 -->
                <div class="table-form">
                    <table class="horizontal" v-if="corpJoinStateList !== null">
                        <tr>
                            <th rowspan="2"><KSACheckBox v-model="isSelectedAll" /></th>
                            <th rowspan="2">NO</th>
                            <th rowspan="2">참가 상태</th>
                            <th rowspan="2">심사 상태</th>
                            <th rowspan="2" class="border-right">기업명</th>
                            <th colspan="3">신청 마스터</th>
                            <th rowspan="2">
                                <span v-if="tabIndex2 === 1 || tabIndex2 === 2">참가 상태 변경일</span>
                                <span v-if="tabIndex2 === 3">승인일(참가확정)</span>
                                <span v-if="tabIndex2 === 4">반려일(참가불가)</span>
                                <span v-if="tabIndex2 === 5">신청 취소일</span>
                            </th>
                            <th rowspan="2">참가 신청일</th>
                            <th rowspan="2">신청정보</th>
                            <th rowspan="2">신청 채용공고</th>
                            <th rowspan="2" v-if="tabIndex2 === 3">전체 채용공고</th>
                            <th rowspan="2" v-if="tabIndex2 === 3">전체 입사지원</th>
                        </tr>
                        <tr>
                            <th>회원코드</th>
                            <th>이름</th>
                            <th>아이디</th>
                        </tr>
                        <tr v-for="ojf in corpJoinStateList">
                            <td><KSACheckBox v-model="ojf.checked" /></td>
                            <td>{{ ojf.boardNo }}</td>
                            <td>
                                <span :class="ojf.joinStateGb === '11' ? 'blue' : ojf.joinStateGb === '21' ? 'red' : ojf.joinStateGb === '03' || ojf.joinStateGb === '04' ? 'gray' : ''">{{ $gbNameKR("ADMIN_JOIN_STATE_GB", ojf.joinStateGb) }}</span>
                            </td>
                            <td>
                                <span :class="ojf.joinStateGb === '11' ? 'blue' : ojf.joinStateGb === '21' ? 'red' : ojf.joinStateGb === '03' || ojf.joinStateGb === '04' ? 'gray' : ''">{{ $gbNameKR("ADMIN_JOIN_STATE_GB", ojf.joinStateGb) }}</span>
                            </td>
                            <td class="clickable blue">
                                <RouterLink :to="{name:'CorporationDetail', params:{id: ojf.corpId}}">{{ ojf.corpName }}</RouterLink>
                            </td>
                            <td>{{ ojf.userCd }}</td>
                            <td class="clickable blue">
                                <RouterLink :to="{name: 'MemberDetail', params:{id: ojf.userCd}}">{{ ojf.userName }}</RouterLink>
                            </td>
                            <td>{{ ojf.userLoginId }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.joinStateModifyDate) }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                            <td :class="ojf.corpId !== undefined && ojf.corpId !== null ? 'clickable blue' : 'gray'" @click="onClickRecruitmentHallCorp(ojf.corpId)">신청정보</td>
                            <td :class="ojf.jobNoticeSeq !== undefined && ojf.jobNoticeSeq !== null ? 'clickable blue' : 'gray'" @click="onClickJobNotice(ojf.jobNoticeSeq, ojf.corpId)">채용공고</td>
                            <td v-if="tabIndex2 === 3">{{ ojf.jobNoticeSeqCnt }}</td>
                            <td v-if="tabIndex2 === 3">{{ ojf.applicantCnt }}</td>
                        </tr>
                    </table>
                    <div class="result-none" v-if="corpJoinStateList.length === 0">
                        참가 신청 내역이 없습니다.
                    </div>
                </div>
                <Paginate
                    v-if="corpJoinStateList.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
            </div>
        </div>
        <!-- e: tabIndex 1 : 재직자/기업 -->
        <!-- s: tabIndex 2 : 학생/취업준비생 -->
        <div v-else-if="tabIndex === 2">
            <KSATab style="grid-template-columns: repeat(5, 1fr);" class="mb-lg"
                    :options="[
                                        {label: `참가신청${'(' + stuJoinStateCnt.totalJoinState + ')'}`, value: 1},
                                        {label: `신청검토중${'(' + stuJoinStateCnt.joinState02 + ')'}`, value: 2},
                                        {label: `승인-참가확정${'(' + stuJoinStateCnt.joinState11 + ')'}`, value: 3},
                                        {label: `반려-참가불가${'(' + stuJoinStateCnt.joinState21 + ')'}`, value: 4},
                                        {label: `취소${'(' + (Number(stuJoinStateCnt.joinState03) + Number(stuJoinStateCnt.joinState04)) + ')'}`, value: 5},
                                    ]"
                    @change="onChangeTab2"
            />
            <div>
                <!-- s: 검색 -->
                <div class="filter-wrap" :class="{'open': searchOpen}">
                    <p @click="searchOpen = !searchOpen">검색</p>
                    <div class="filter">
                        <dl v-show="tabIndex2 === 1">
                            <dt style="display:block;"><span>진행 상태</span><br /><small style="font-weight: normal;">복수 선택
                                가능</small></dt>
                            <dd>
                                <KSACheckBoxGroup
                                    ref="adminJoinStateGbsListRef"
                                    className="mr-md"
                                    name="ojfStateGbList"
                                    v-model="searchInput.joinStateGbsList"
                                    :options="adminJoinStateGb" />
                            </dd>
                        </dl>
                        <!-- 이름, 아이디, 회원코드 검색 -->
                        <dl>
                            <dt>
                                <KSASelect ref="searchTypeRef" :options="searchTypeGroupStu" class="select" @selectOption="onSelectSearchTypeGroup"/>
                            </dt>
                            <dd>
                                <KSAInput class="text-box" v-model="searchInput.searchInput" :placeholder="searchInputPlaceholderStu" />
                            </dd>
                        </dl>
                        <dl>
                            <dt>참가 신청일</dt>
                            <dd class="text-box">
                                <div class="grid">
                                    <template v-for="group in searchDurationTypeGroup" key="item.value" >
                                        <KSARadioButton class="mr-md" name="searchDurationGb" :label="group.label" v-model="searchInput.searchDurationType" :value="group.value" />
                                    </template>
                                    <div style="display: inline-block;" v-show="searchInput.searchDurationType !== 'all'">
                                        <KSADatepickerTerms
                                            ref="datepickerTermsRef2"
                                            :startDate="searchInput.startYmd"
                                            :endDate="searchInput.endYmd"
                                            @update:startDate="(value)=> searchInput.startYmd = value"
                                            @update:endDate="(value)=> searchInput.endYmd = value"
                                        />
                                    </div>
                                </div>
                            </dd>
                        </dl>
                        <div class="btn-wrap">
                            <KSASecondaryButton class="gray_button" text="초기화" @click="clearSearchInput" />
                            <KSAPrimaryButton text="검색" @click="onClickSearch" />
                        </div>
                    </div>
                </div>
                <!-- e: 검색 -->
                <!-- s: 버튼영역 -->
                <div class="list-top">
                    <div class="grid">
                        <KSAPrimaryButton v-if="tabIndex2 === 1" text="엑셀 다운로드" @click="onClickStuExcelDownload" />
                        <KSADropdownButton v-if="tabIndex2 === 1 || tabIndex2 === 2" class="gray_button ml-xs" text="참가 상태 변경" :options="adminJoinStateGBList" @click="onClickStuJoinState" />
                    </div>
                    <div>
                        <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize" />
                    </div>
                </div>
                <!-- e: 버튼영역 -->
                <div class="table-form">
                    <table class="horizontal" v-if="stuJoinStateList !== null">
                        <tr>
                            <th><KSACheckBox v-model="isSelectedAll" /></th>
                            <th>NO</th>
                            <th>참가 상태</th>
                            <th>회원코드</th>
                            <th>이름</th>
                            <th>아이디</th>
                            <th>
                                <span v-if="tabIndex2 === 1 || tabIndex2 === 2">참가 상태 변경일</span>
                                <span v-if="tabIndex2 === 3">승인일(참가확정)</span>
                                <span v-if="tabIndex2 === 4">반려일(참가불가)</span>
                                <span v-if="tabIndex2 === 5">신청 취소일</span>
                            </th>
                            <th>참가 신청일</th>
                            <th>신청정보</th>
                            <th>신청 이력서</th>
                            <th v-if="tabIndex2 === 3">전체 이력서</th>
                            <th v-if="tabIndex2 === 3">전체 입사지원</th>
                        </tr>
                        <tr v-for="ojf in stuJoinStateList">
                            <td><KSACheckBox v-model="ojf.checked" /></td>
                            <td>{{ ojf.boardNo }}</td>
                            <td><span :class="ojf.joinStateGb === '11' ? 'blue' : ojf.joinStateGb === '21' ? 'red' : ojf.joinStateGb === '03' || ojf.joinStateGb === '04' ? 'gray' : ''">{{ $gbNameKR("ADMIN_JOIN_STATE_GB", ojf.joinStateGb) }}</span></td>
                            <td>{{ ojf.userCd }}</td>
                            <td class="clickable blue">
                                <RouterLink :to="{name: 'MemberDetail', params:{id: ojf.userId}}">{{ ojf.userName }}</RouterLink>
                            </td>
                            <td>{{ ojf.userLoginId }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.joinStateModifyDate) }}</td>
                            <td>{{ $yyyymmddHHmmss(ojf.createDate) }}</td>
                            <td :class="ojf.userId !== undefined && ojf.userId !== null ? 'clickable blue' : 'gray'" @click="onClickRecruitmentHall(ojf.userId)">신청정보</td>
                            <td :class="ojf.resumeId !== undefined && ojf.resumeId !== null ? 'clickable blue' : 'gray'" @click="onClickMyResume(ojf.resumeId)">신청 이력서</td>
                            <td v-if="tabIndex2 === 3">{{ ojf.resumeCnt }}</td>
                            <td v-if="tabIndex2 === 3">{{ ojf.applicantCnt }}</td>
                        </tr>
                    </table>
                    <div class="result-none" v-if="stuJoinStateList.length === 0">
                        참가 신청 내역이 없습니다.
                    </div>
                </div>
                <Paginate
                    v-if="stuJoinStateList.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :click-handler="onSelectPage"
                />
            </div>
        </div>
        <!-- e: tabIndex 1 : 학생/취업준비생 -->
    </div>
    <RecruitmentHallCorpModal ref="recruitmentHallCorpModal" /> <!-- 신청정보 보기 - 기업 -->
    <RecruitmentHallModal ref="recruitmentHallModal" /> <!-- 신청정보 보기 - 구직자 -->
    <JobFairJobNoticeModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
    <JobFairResumeModal ref="jobFairResumeModal" /> <!-- 이력서 보기 -->
</template>

<style lang="scss" scoped>
@import "../../../../../assets/scss/theme";

.textarea-box {
    height: 100px;
}
.blue {
  color: $blue_color;
}
.red {
  color: $red_color;
}
.gray {
  color: $gray_color;
}

.table-form {
    table {
        &.vertical {
            &.align-left {
                th {
                    text-align: left;
                    span {
                        display: block;
                        font-size: $font-size_xs;
                        color: $gray_color;
                        font-weight: normal;
                    }
                }
            }
        }
    }
    .clickable {
        text-decoration: underline;
        cursor: pointer;
    }
}
</style>